export default "__VITE_ASSET__a5d4224d__"